import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import {
	buildBoundingBox,
	buildElementInfo,
	buildTaskManagerTickets,
	MOBILE_SEVERITY_MAP
} from 'src/common/helpers/MobileQueriesHelper';
import {
	MobileCommentData,
	MobileIssueDetails,
	MobileWcagCriteria
} from 'src/common/types/MobileSingleSessionTypes';

import { MfaIssueDetailsQuery } from '../MfaIssueDetails.generated';

const transformIssueToMobileIssueDetails = (
	issue: NonNullable<NonNullable<MfaIssueDetailsQuery['issues']>[0]>,
	userName: string
): MobileIssueDetails => {
	const elementInfo = buildElementInfo(issue);
	const taskManagerTickets = buildTaskManagerTickets(issue);
	const boundingBox = buildBoundingBox(issue);

	// Parse WCAG criteria from tags if available
	const wcagCriteria: MobileWcagCriteria[] = [];
	issue.tags__description?.forEach((item, index) => {
		const title = item.trim();
		const link = issue.tags__link?.[index].trim();

		if (title && link) {
			wcagCriteria.push({ title, link });
		}
	});

	// prepare comment data
	const comment: MobileCommentData | undefined = issue.note
		? {
				text: issue.note,
				lastModified: issue.note_creation_time,
				user: userName
			}
		: undefined;

	return {
		type: issue.type_name,
		description: issue.description,
		comment,
		severity: MOBILE_SEVERITY_MAP[issue.severity_name],
		signature: issue.signature,
		screenshotDetails: {
			pageScreenshotUrl: issue.screenshot,
			boundingBox,
			viewportWidth: issue.viewport_width,
			viewportHeight: issue.viewport_height
		},
		taskManagerTickets,
		elementInfo,
		knowledgeBaseLink: issue.knowledge_base_link,
		expectations: [], // replace when schema will support issue expectations
		WCAGCriteria: wcagCriteria
	};
};

export const transformMfaIssueDetailsResults = (
	result: MfaIssueDetailsQuery
): MobileIssueDetails | null => {
	const issues = result.issues?.filter(returnNonNull);

	if (!issues?.length) {
		return null;
	}

	const sessionRuns = result.mfa_session_runs?.filter(returnNonNull);
	const userName = sessionRuns?.[0]?.user_name ?? '';

	return transformIssueToMobileIssueDetails(issues[0], userName);
};
